


















































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleteClinicStates from '@/components/simple-therapy/autocomplete-clinic-states.vue';
import UiAutocompleteClinicsSituations from '@/components/simple-therapy/autocomplete-clinics-situations.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import * as service from '@/services/therapy';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import SimpleTherapyForm from '../../../components/simple-therapy/simple-therapy-form.vue';
import { PaginationSyncDTO, ResultPagDTO } from '../../../interfaces/base-dto';
import { FiltroTerapiaSimplParmDTO, TerapiaListItemDTO } from '../../../interfaces/therapy';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    UiAutocompleClientsSubsidiaries,
    SimpleTherapyForm,
    UiAutocompleteClinicsSituations,
    UiAutocompleteClinicStates    
  },
})
export default class SimpleTherapy extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public pagina: ResultPagDTO<TerapiaListItemDTO> = new ResultPagDTO<TerapiaListItemDTO>();
  public items: TerapiaListItemDTO[] = [];
  public id: Number = null;

  public filtros: FiltroTerapiaSimplParmDTO = new FiltroTerapiaSimplParmDTO();
  situacoesClinicas = [];
  private unidade: any = {};
  clinicSituationsList: any[] = [];
  clinicSituationsLoading = false;
  ofertas: any[] = [];  

  public headers: any = [
    { text: 'Código', value: 'codigo', sortable: true },
    { text: 'Nome', value: 'nome', sortable: true },
    //{ text: 'Via Administração', value: 'viaAdministracao', sortable: true },
    //{ text: 'Tipo', value: 'npt', sortable: true },
    //{ text: 'Oferta Nutricional', value: 'ofertaNutricional', sortable: true },
    { text: 'Estado Clínico', value: 'estadoClinico', sortable: true },
    { text: 'Situações Clínicas', value: 'situacoesClinicas', sortable: false },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];

  private pagination: PaginationSyncDTO = new PaginationSyncDTO();

  private mounted(): void {
    this.loadClinicSituations();
    this.loadNutritionOffers();
    this.pesquisar();
  }

  private loadClinicSituations(): void {
    this.clinicSituationsLoading = true;
    service.listClinicSituations(null).subscribe((res) => {
      this.clinicSituationsList = res;
      this.clinicSituationsLoading = false;
    });
  }

  private loadNutritionOffers() {
    service.listNutritionOffers().subscribe((res) => {
      this.ofertas = res;
    });
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangeSearch() {
    if (this.loading) {
      return;
    }
    this.pesquisar();
  }

  private pesquisar() {
    this.items = [];
    this.loading = true;
    this.error = false;
    let f = this.filtros;
    f.idUnidade = this.unidade ? this.unidade.id : null;
    f.idsSituacoesClinicas = this.situacoesClinicas ? this.situacoesClinicas.map((s) => s.id) : [];
    f.update(this.pagination);
    this.addSubsc(
      service.listSimpleTherapies(f).subscribe(
        (result) => {
          this.loading = false;
          this.pagina = result;
          this.items = this.pagina.content;
          PaginationSyncDTO.update(this.pagination, result);
        },
        () => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }

  private newItem(): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = null;
  }

  private onEditItem(item): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = item.id;
  }

  private closeForm(): void {
    this.formOpen = false;
    this.id = null;
  }

  private saveItem(): void {
    this.closeForm();
    this.pesquisar();
  }
}
